// money — form helpers for the bigint minor-units money path (money is bigint
// end-to-end). All amounts are 2-decimal minor units (paise / cents), matching
// fmtCcyMinor which divides by 100n. NEVER parseFloat money — parse the digits.

/**
 * parseMinorFromMajor turns a user-typed major-unit string ("1499",
 * "1499.5", "1,499.50") into bigint minor units, or null if it isn't a valid
 * non-negative amount with at most 2 decimal places. String math only — no
 * float coercion.
 */
export function parseMinorFromMajor(input: string): bigint | null {
  const trimmed = input.trim().replace(/,/g, "");
  if (trimmed === "") return null;
  const m = /^(\d+)(?:\.(\d{1,2}))?$/.exec(trimmed);
  if (!m) return null;
  const whole = m[1];
  const frac = (m[2] ?? "").padEnd(2, "0");
  return BigInt(whole) * 100n + BigInt(frac);
}

/**
 * minorToMajorInput turns bigint minor units into a plain major-unit string
 * ("149950" → "1499.50") suitable for seeding an editable text input. Always
 * emits 2 decimal places.
 */
export function minorToMajorInput(minor: bigint): string {
  const neg = minor < 0n;
  const abs = neg ? -minor : minor;
  const whole = abs / 100n;
  const frac = abs % 100n;
  return (neg ? "-" : "") + whole.toString() + "." + frac.toString().padStart(2, "0");
}
